
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1R4BF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ef529700267c64b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2rSXm = parcelRequire("2rSXm");

var $jWuk1 = parcelRequire("jWuk1");

var $giAhk = parcelRequire("giAhk");

var $3duPG = parcelRequire("3duPG");

var $kJlBc = parcelRequire("kJlBc");

var $3aRjT = parcelRequire("3aRjT");
const $ef529700267c64b8$var$CrossIconMedium = (0, $giAhk.injectIntlV2)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        size: "medium",
        label: props.intl.formatMessage((0, $3aRjT.default).close)
    }));
const $ef529700267c64b8$var$DrawerContent = (props)=>{
    const { onClose: onClose, baseUrl: baseUrl, isAdmin: isAdmin, isOnboarding: isOnboarding, data: data, appEditions: appEditions, methods: methods, onScreenChange: onScreenChange, onPermissionsFetched: onPermissionsFetched, ProjectCreate: ProjectCreate } = props;
    const defaultSelectedTemplateKey = data.defaultSelectedTemplateKey !== undefined ? data.defaultSelectedTemplateKey : (0, $3duPG.defaultProps).defaultSelectedTemplateKey;
    const isTemplatePickerOpenInitially = data.isTemplatePickerOpenInitially !== undefined ? data.isTemplatePickerOpenInitially : (0, $3duPG.defaultProps).isTemplatePickerOpenInitially;
    const isImportProjectOpenInitially = data.isImportProjectOpenInitially !== undefined ? data.isImportProjectOpenInitially : (0, $3duPG.defaultProps).isImportProjectOpenInitially;
    const selectedProjectType = data.selectedProjectType !== undefined ? data.selectedProjectType : (0, $3duPG.defaultProps).selectedProjectType;
    let source = data.source !== undefined ? data.source : (0, $3duPG.defaultProps).source;
    // https://softwareteams.atlassian.net/browse/RLSS-4346
    const [originSource] = (0, $kJlBc.useQueryParam)('originSource');
    if (!source && originSource !== undefined) source = originSource;
    const drawerOverrides = {
        Sidebar: {
            component: ()=>null
        },
        // @ts-expect-error - TS7006 - Parameter 'styles' implicitly has an 'any' type.
        Content: {
            cssFn: (styles)=>({
                    ...styles,
                    margin: 0
                })
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2rSXm.default), {
        isOpen: data.isOpen,
        width: "full",
        onClose: onClose,
        icon: $ef529700267c64b8$var$CrossIconMedium,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: drawerOverrides,
        autoFocusFirstElem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectCreate, {
        baseUrl: baseUrl,
        isAdmin: isAdmin,
        isOnboarding: isOnboarding,
        isJswOnboarding: false,
        isJiraCoreOnboarding: false,
        skipTemplateSelection: false,
        isNextGen: data.isNextGen,
        showExperienceSelection: data.showExperienceSelection,
        recommendedTemplate: data.recommendedTemplate,
        isConnectedProjectScenario: false,
        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
        isImportProjectOpenInitially: isImportProjectOpenInitially,
        selectedProjectType: selectedProjectType,
        appEditions: appEditions,
        onCancel: methods.close,
        onSuccess: methods.onSuccess,
        onScreenChange: onScreenChange,
        onPermissionsFetched: onPermissionsFetched,
        source: source,
        onDrawerClose: onClose,
        setOnCloseCallback: methods.setOnCloseCallback,
        onCreateStarted: methods.onCreateStarted,
        recommendationSessionID: data.recommendationSessionId
    }));
};
var $ef529700267c64b8$export$2e2bcd8739ae039 = $ef529700267c64b8$var$DrawerContent;

});
parcelRegister("3duPG", function(module, exports) {

$parcel$export(module.exports, "PROJECT_NAME_MUST_HAVE_ONE_VALIDATION_ERROR", () => $4f7540c810b73236$export$1df4ba98d152148f);
$parcel$export(module.exports, "PROJECT_NAME_ALREADY_EXISTS_VALIDATION_ERROR", () => $4f7540c810b73236$export$1a6511c8e3d90b01);
$parcel$export(module.exports, "PROJECT_NAME_TOO_LONG_VALIDATION_ERROR", () => $4f7540c810b73236$export$e01752a0edf6357);
$parcel$export(module.exports, "PROJECT_NAME_TOO_SHORT_VALIDATION_ERROR", () => $4f7540c810b73236$export$30ed0c21e0541d54);
$parcel$export(module.exports, "AGILITY_SCRUM", () => $4f7540c810b73236$export$419614a75e3c8c96);
$parcel$export(module.exports, "AGILITY_KANBAN", () => $4f7540c810b73236$export$65a1f1d90570ca24);
$parcel$export(module.exports, "CLASSIC_KANBAN", () => $4f7540c810b73236$export$5440382b762f7979);
$parcel$export(module.exports, "CLASSIC_SCRUM", () => $4f7540c810b73236$export$3548d21fa371324);
$parcel$export(module.exports, "FlagType", () => $4f7540c810b73236$export$36f7d6a88f12c6f1);
$parcel$export(module.exports, "TEMPLATE_RECOMMENDED", () => $4f7540c810b73236$export$b05e60fc5e493864);
$parcel$export(module.exports, "TEMPLATE_USER_CHOSEN", () => $4f7540c810b73236$export$cfc293ddb62ce0c1);
$parcel$export(module.exports, "ScreenType", () => $4f7540c810b73236$export$739ce3adec75fd20);
$parcel$export(module.exports, "PROJECT_SHARED_CONFIG_NAME", () => $4f7540c810b73236$export$5b1e7155f957f879);
$parcel$export(module.exports, "PROJECT_SHARED_CONFIG_DESCRIPTION", () => $4f7540c810b73236$export$2340e239460b4b15);
$parcel$export(module.exports, "projectWithSharedConfigurationTemplateNew", () => $4f7540c810b73236$export$5e4885ad7bef0832);
$parcel$export(module.exports, "projectWithSharedConfigurationTemplateOld", () => $4f7540c810b73236$export$1cde308aaf9290d3);
$parcel$export(module.exports, "CONTAINER_LINKING_ENTITY_PROPERTY_KEY", () => $4f7540c810b73236$export$d75ef12ea85be6e9);
$parcel$export(module.exports, "TEAM_NAME", () => $4f7540c810b73236$export$d57b6b390e78d90f);
$parcel$export(module.exports, "BACK_TO_PROJECT_TYPES", () => $4f7540c810b73236$export$9be72cd0551f5635);
$parcel$export(module.exports, "BACK_TO_PROJECT_TEMPLATES", () => $4f7540c810b73236$export$bd0b65a432910549);
$parcel$export(module.exports, "CHANGE_TEMPLATE", () => $4f7540c810b73236$export$8846f056194ea535);
$parcel$export(module.exports, "CHANGE_PROJECT_TYPE", () => $4f7540c810b73236$export$d12aafb7071e830e);
$parcel$export(module.exports, "VIEW_TEMPLATE_OVERVIEW", () => $4f7540c810b73236$export$9ed04c8d3ebcadc8);
$parcel$export(module.exports, "CREATE_PROJECT_SOURCE_NAME", () => $4f7540c810b73236$export$6c31fc7edf30602b);
$parcel$export(module.exports, "defaultProps", () => $4f7540c810b73236$export$9c21a3269931e1e6);

var $jG2Eu = parcelRequire("jG2Eu");
parcelRequire("38Ame");
var $heysF = parcelRequire("heysF");

var $evtBt = parcelRequire("evtBt");
const $4f7540c810b73236$export$1df4ba98d152148f = 'PROJECT_NAME_MUST_HAVE_ONE_VALIDATION_ERROR';
const $4f7540c810b73236$export$1a6511c8e3d90b01 = 'PROJECT_NAME_ALREADY_EXISTS_VALIDATION_ERROR';
const $4f7540c810b73236$export$e01752a0edf6357 = 'PROJECT_NAME_TOO_LONG_VALIDATION_ERROR';
const $4f7540c810b73236$export$30ed0c21e0541d54 = 'PROJECT_NAME_TOO_SHORT_VALIDATION_ERROR';
const $4f7540c810b73236$export$419614a75e3c8c96 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $4f7540c810b73236$export$65a1f1d90570ca24 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $4f7540c810b73236$export$5440382b762f7979 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $4f7540c810b73236$export$3548d21fa371324 = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $4f7540c810b73236$export$36f7d6a88f12c6f1 = {
    PROJECT_CREATION_FAILURE: 'PROJECT_CREATION_FAILURE_FLAG'
};
const $4f7540c810b73236$export$b05e60fc5e493864 = 'TEMPLATE_RECOMMENDED';
const $4f7540c810b73236$export$cfc293ddb62ce0c1 = 'TEMPLATE_USER_CHOSEN';
const $4f7540c810b73236$export$739ce3adec75fd20 = {
    FORM: 'FORM',
    FORM_WITH_PROJECT_TYPE_DROPDOWN: 'FORM_WITH_PROJECT_TYPE_DROPDOWN',
    ERROR_PAGE: 'ERROR_PAGE',
    EXPERIENCE_SELECTION: 'EXPERIENCE_SELECTION',
    CONTAINER_LINKING: 'CONTAINER_LINKING',
    NEW_TEMPLATE_CHOICE: 'NEW_TEMPLATE_CHOICE'
};
const $4f7540c810b73236$export$320af64b1bd103c2 = 'PROJECT_SHARED_CONFIG_KEY';
const $4f7540c810b73236$export$5b1e7155f957f879 = 'PROJECT_SHARED_CONFIG_NAME';
const $4f7540c810b73236$export$2340e239460b4b15 = 'PROJECT_SHARED_CONFIG_DESCRIPTION';
const $4f7540c810b73236$export$5e4885ad7bef0832 = {
    key: $4f7540c810b73236$export$320af64b1bd103c2,
    name: $4f7540c810b73236$export$5b1e7155f957f879,
    description: $4f7540c810b73236$export$2340e239460b4b15,
    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($heysF))),
    // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type '"business" | "software" | "service_desk" | "product_discovery"'.
    projectTypeKey: undefined,
    infoPages: [],
    features: undefined,
    simplified: false
};
const $4f7540c810b73236$export$1cde308aaf9290d3 = {
    key: $4f7540c810b73236$export$320af64b1bd103c2,
    name: $4f7540c810b73236$export$5b1e7155f957f879,
    description: $4f7540c810b73236$export$2340e239460b4b15,
    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($evtBt))),
    // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type '"business" | "software" | "service_desk" | "product_discovery"'.
    projectTypeKey: undefined,
    infoPages: [],
    features: undefined,
    simplified: false
};
const $4f7540c810b73236$export$d75ef12ea85be6e9 = 'DevopsContainerLinkingDefaultPreference';
const $4f7540c810b73236$export$a9e747841ed04a78 = 'create-project-container-linking';
const $4f7540c810b73236$export$d57b6b390e78d90f = 'helix';
const $4f7540c810b73236$export$9be72cd0551f5635 = 'backToProjectTypes';
const $4f7540c810b73236$export$bd0b65a432910549 = 'backToProjectTemplates';
const $4f7540c810b73236$export$8846f056194ea535 = 'changeTemplate';
const $4f7540c810b73236$export$d12aafb7071e830e = 'changeProjectType';
const $4f7540c810b73236$export$9ed04c8d3ebcadc8 = 'viewTemplateOverview';
const $4f7540c810b73236$export$6c31fc7edf30602b = 'createProject';
const $4f7540c810b73236$export$9c21a3269931e1e6 = {
    isImportProjectOpenInitially: false,
    isTemplatePickerOpenInitially: false,
    isNextGen: false,
    isJswOnboarding: false,
    isOnboarding: false,
    isConnectedProjectScenario: false,
    isJiraCoreOnboarding: false,
    skipTemplateSelection: false,
    recommendedTemplate: undefined,
    defaultSelectedTemplateKey: '',
    source: '',
    showExperienceSelection: false,
    selectedProjectType: null,
    recommendationSessionId: undefined,
    onScreenChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onPermissionsFetched: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onDrawerClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isBusinessUser: false
};
const $4f7540c810b73236$export$f2d43e25df693c47 = 'FIRST';
const $4f7540c810b73236$export$385d914547f5b1a5 = 'My first project';

});
parcelRegister("38Ame", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("heysF")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $heysF = parcelRequire("heysF");
const $b17095f92a24b6cd$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($heysF)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($heysF))
});
var $b17095f92a24b6cd$export$2e2bcd8739ae039 = $b17095f92a24b6cd$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $b17095f92a24b6cd$export$a179c88182cb9d56 = [
    0,
    0,
    48,
    40
];

});
parcelRegister("9TZf5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $a7efac7c92ef32a3$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $a7efac7c92ef32a3$export$4d00e7be716a0093);

var $eUqFw = parcelRequire("eUqFw");

var $evtC7 = parcelRequire("evtC7");
function $a7efac7c92ef32a3$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $evtC7.AsImg), props);
}
function $a7efac7c92ef32a3$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efac7c92ef32a3$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("evtC7", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $e7036c28dfac32f8$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");
// suggested defaults, the consumer is free to override
const $e7036c28dfac32f8$var$defaultStyles = null;
const $e7036c28dfac32f8$var$fillStyles = null;
const $e7036c28dfac32f8$var$autoDarkModeStyles = null;
function $e7036c28dfac32f8$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("heysF", function(module, exports) {
module.exports = new URL("shared-folder.0c3dee65.svg", import.meta.url).toString();

});


parcelRegister("evtBt", function(module, exports) {
module.exports = new URL("project-with-shared-configuration-icon.e5c37209.svg", import.meta.url).toString();

});


parcelRegister("3aRjT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7095bcaf8c7eb44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d7095bcaf8c7eb44$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    close: {
        "id": "navigation-next.project-create-drawer.close",
        "defaultMessage": "Close"
    }
});

});



//# sourceMappingURL=async-project-create-drawer.9639203c.js.map
